import { render, staticRenderFns } from "./ManagerShare.vue?vue&type=template&id=28aaa053"
import script from "./ManagerShare.vue?vue&type=script&lang=ts"
export * from "./ManagerShare.vue?vue&type=script&lang=ts"
import style0 from "./ManagerShare.vue?vue&type=style&index=0&id=28aaa053&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports